"use client";

import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap justify-start">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground/80 hover:text-foreground hover:underline transition-colors duration-[var(--duration-medium)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function PiedDePage() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-background border-t border-border py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <MenuProvider menu_id="10" className="flex-1">
            <FooterMenuConsumer />
          </MenuProvider>

          <div className="flex items-center gap-4">
            <Link to="https://www.instagram.com/the.joker.studio/?hl=en" newTab className="text-primary/70 hover:text-primary transition-opacity duration-[var(--duration-medium)]" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>

        <div className="mt-6 text-center text-sm text-foreground/60">
          © {currentYear} JokerStudio. Tous droits réservés.
        </div>
      </div>
    </footer>;
}